import { searchApiURL } from "API/urls/search.api";
import { axiosInstance } from "configs/axios";

export const searchUserApi = async (query, deptFilter) => {
  try {
    const response = await axiosInstance.post(searchApiURL.users, {
      query,
      deptFilter,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
